import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RestService } from './rest.service';
import { StorageService, PriceData } from './storage.service';
import { Router } from '@angular/router';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentCodeService {
  private priceSubject = new BehaviorSubject<PriceData | null>(null);
  public price$ = this.priceSubject.asObservable();

  constructor(
    private restService: RestService,
    private storageService: StorageService,
    private router: Router,
    private translationService: TranslationService,
  ) {
    // Initialize price subject from storage if exists
    const savedPrice = this.storageService.getPriceData();
    if (savedPrice) {
      this.priceSubject.next(savedPrice);
    }
  }

  public async processQueryParams(queryParams: any): Promise<boolean> {
    const pageCode = queryParams['page'];

    if (pageCode) {
      await this.saveCodeAndFetchPrice(pageCode);
      return true;
    }

    return false;
  }

  public async saveCodeAndFetchPrice(
    code?: string,
    scanId?: string,
  ): Promise<void> {
    if (code) {
      this.storageService.setPaymentCode(code);
    }

    try {
      const response = await this.restService.request<PriceData>({
        path: 'payment/decode-price',
        method: 'GET',
        // lang picks the no-link default plan prices (he = ILS, en = USD).
        queryParams: { ...(scanId ? { scanId } : {}), lang: this.translationService.getCurrentLanguage() },
      });

      if (response) {
        this.storageService.setPriceData(response);
        this.priceSubject.next(response);
      }
    } catch (error) {
      console.error('Failed to fetch price:', error);
    }
  }

  public getCurrentPriceData(): PriceData | null {
    return this.storageService.getPriceData() || this.priceSubject.value;
  }

  public getCurrentPrice(): string | null {
    return this.getCurrentPriceData()?.price || null;
  }

  public getCurrentOldPrice(): string | null {
    return this.getCurrentPriceData()?.oldPrice || null;
  }
}
